<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="收款单"
      :page="page"
      :show-query="true"
      show-checkbox
      v-if="trendShow"
      @check-change="checkChange"
      @row-select="rowSelect"
      :queryParamsAppend="{}"
      :temp-params="tempParams"
      :summary-method="summaryFunc"
      :show-summary="summaryShow"
      :get-data-func="getDataFunc"
      urlHash="finance/cashier/receivables"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <el-table
      v-show="tableData.length !== 0"
      border
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      style="margin-top: 18px"
    >
      <el-table-column
        prop="SettleName"
        label="结算方式"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="AccountName"
        label="收款账户"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ReceiptAmount"
        label="收款金额"
        min-width="100"
        align="right"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">{{
          row.ReceiptAmount.toLocaleString()
        }}</template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="备注"
        min-width="100"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/receipt").default,
      trendShow: true,
      list: [],
      tableData: [],
      tempParams: {},
      summaryShow:false,
      total: 0,
    };
  },
  activated() {
    this.getRouterInfo();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/cashier/receivables");
    },
  },

  methods: {
    getDataFunc(params) {
      console.log("getDataFunc", params);
      return new Promise((resolve, reject) => {
        this.api.list(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.listTotal(params).then(res => {
              console.log("total", res)
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["ReceiptAmount","PuQuantity", "Amount",'TaxLimit','SettlementAmount','RestAmount','StockInQuantity','StockInQuantity2','InvoiceQuantity','InvoiceQuantity2','RefundQuantity','RefundQuantity2','TaxAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    review(){
      if (this.list.length === 0) {
        this.$message({ type: "warning", message: "请勾选要审核的记录" });
        return;
      }
      let ids = this.list.map((item) => {
        return item.DocId;
      });

      this.$confirm("是否审核？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.review({ Ids: ids }).then((res) => {
            if (res.Code === 0) {
              this.$message({ type: "success", message: res.Msg });
              this.$emit("reviewed");
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.getListExport(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    getRouterInfo() {
      console.log(
        "this.$router.history.current.params",
        this.$router.history.current.params
      );
      if (this.$router.history.current.params) {
        this.tempParams.SourceDocId = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceDocId,
        };
        this.tempParams.SaOrderNo = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SaOrderNo,
        };
        this.tempParams.SourceType = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceType,
        };

        this.$refs.list.getData();
      }
    },
    checkChange(list) {
      this.list = list;
    },
    rowSelect({ DocId }) {
      this.api.info(DocId).then((res) => {
        if (res.Code === 0) {
          this.tableData = res.Data.Dts;
        }
      });
    },
    del() {
      if (this.list.length === 0) {
        this.$message({ type: "warning", message: "请勾选要删除的记录" });
        return;
      }
      let ids = this.list.map((item) => {
        return item.DocId;
      });
      this.$confirm("是否删除数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Ids: ids }).then((res) => {
            if (res.Code === 0) {
              this.$message({ type: "success", message: res.Msg });
              this.$emit("deleted");
            } else {
              this.$message({ type: "warning", message: res.Msg });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
